module.exports = __webpack_public_path__ + "static/media/thumb.f4c578ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/contact/thumb.jpg
// module id = 41
// module chunks = 0